import React from 'react';

export interface props {
  children: React.ReactNode;
}

export const Main: React.FC<props> = ({ children }) => {
  return <div className={'main-body-wrapper'}>{children}</div>;
};

export default Main;
